'use client';
import * as React from 'react';

import { ProfileLoading, useProfileStore } from '../../stores/profile-store';
import { SubmitButton } from '../../../ui/shared';

interface ProfileFormProps {
  buttonText: string;
  disabled: boolean;
}

const FormActionButton: React.FC<ProfileFormProps> = ({ buttonText, disabled }) => {
  const { isLoading } = useProfileStore();
  return (
    <SubmitButton
      buttonText={buttonText}
      isLoading={isLoading === ProfileLoading.UPDATE}
      isDisabled={disabled}
    />
  );
};

export default FormActionButton;
